import { render } from "./ManagementSupportPage.vue?vue&type=template&id=5fab460a"
import script from "./ManagementSupportPage.vue?vue&type=script&lang=js"
export * from "./ManagementSupportPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__